import { MessageSquare, ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import type { GestorJornadaDashboard } from '@/services/gestoresService'

type Props = {
  feedbackPendente: GestorJornadaDashboard['feedbackPendente']
  onOpenFeedback: (memberId: string) => void
}

export function GestorJornadaFeedbackAlert({ feedbackPendente, onOpenFeedback }: Props) {
  if (feedbackPendente.length === 0) return null

  const preview = feedbackPendente.slice(0, 3)
  const rest = feedbackPendente.length - preview.length

  return (
    <div className='flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-500/25 bg-amber-500/[0.06] px-4 py-3'>
      <div className='min-w-0'>
        <p className='flex items-center gap-2 text-sm font-medium text-amber-100'>
          <MessageSquare size={16} className='shrink-0 text-amber-400' />
          {feedbackPendente.length} feedback(s) em rascunho aguardando liberação
        </p>
        <p className='mt-1 truncate text-xs text-amber-200/80'>
          {preview.map((p) => p.nomeCompleto).join(' · ')}
          {rest > 0 ? ` · +${rest}` : ''}
        </p>
      </div>
      <Button
        type='button'
        size='sm'
        variant='secondary'
        onClick={() => onOpenFeedback(feedbackPendente[0].id)}
      >
        Revisar
        <ArrowRight size={14} />
      </Button>
    </div>
  )
}
